import React from 'react'
import { BiListPlus } from 'react-icons/bi'
import './SetupAddItem.css'

export default function SetupAddItem({onClick}) {
  return (
    <div className='setupAddButton' onClick={onClick}>
      <div className='setupAddIcon'>
        <BiListPlus />
      </div>
    </div>
  )
}
